import 'UI/Widget/Forms/Control/Input'

NS("UI.Widget.Forms.Control");

UI.Widget.Forms.Control.Checkbox = Class(UI.Widget.Forms.Control.Input, {
    createElement: function() {
        var onClick = this.$control.attr("on-click");

        this.$element = $("<input type='checkbox'>");

        if (onClick) {
            this.$element.attr("on-click", onClick);
        }
    },

    updateElement: function(value) {
        this.$element.prop("checked", !!value);
    },

    listenElement: function() {
        var self = this;

        this.$element.on("click", function() {
            self.setValue($(this).is(":checked"));
        });
    },

    editMode () {
        this.ParentCall()
        this.$element.prop('disabled', false)
    },
    viewMode () {
        this.ParentCall()
        this.$element.prop('disabled', true)
    },
});
